// extracted by mini-css-extract-plugin
export default {"rating":"fF-z","numberOfStars":"gF-z","count":"hF-z","barGraphSpacing":"iF-z","barGraph":"jF-z"};